// 中文語言包
/**
 * common 公共的內容
 * router 路由用到
 * components 公用元件的內容
 * tableColumn
 * form 表單相關標籤/placeholder/options
 * formRules 規則
 * msg
 * error
 * fields 監測屬性
 * units 單位
 * dync 動態參數集合
 *...其他也面用到的翻譯
 */
module.exports = {
  // 公共的內容
  common: {
    enable: '啟用',
    notEnabled: '未啟用',
    allSelect: '全部選中',
    cancelSelect: '全選取消',
    selectAll: '全選',
    passwordAgainPlacecholder: '請再次輸入密碼',
    selectProject: '選擇項目',
    signOut: '退出登錄',
    loading: '載入中',
    reset: '重置',
    next: '下一步',
    submit: '提 交',
    total: '總數',
    corporation: '企業',
    project: '項目',
    structure: '結構物',
    measuringPoint: '測點',
    device: '設備',
    measurement: '監測類型',
    deviceType1: '設備類別',
    search: '查詢',
    chartLoading: '正在生成圖表',
    exportData: '匯出數據',
    exportReport: '匯出報表',
    pleaseSelect: '請選擇',
    pleaseInput: '請輸入',
    all: '全部',
    seeDetails: '查看詳情',
    delete: '刪除',
    cancel: '取消',
    deleteConfig: '删除配置',
    longitude: '經度',
    latitude: '緯度',
    offsetE: '东向偏移量（单位：米）',
    offsetN: '北向偏移量（单位：米）',
    offsetU: '天向偏移量（单位：米）',
    offsetTime: '搬站时间',
    offsetNo: '未搬站',
    edit: '編 輯',
    edit1: '編輯',
    tableLoading: '正在生成表格',
    operationCanceled: '操作取消',
    theme: '主題',
    networkID: '網路識別碼',
    operating: '操作',
    create: '創建',
    update: '更新',
    save: '保存',
    putPointSucess: '保存成功！ 已定位測點 {located} 個，未定位測點 {unlocated} 個',
    sum: '合計',
    success: '操作成功',
    fail: '操作失敗',
    collectorChannelConfig: {
      label: '通道協議',
      col1: '通道號',
      col1Pre: '通道',
      col2: '協議',
      col2Placeholder: '選擇協議',
    },
    confirm: '確定',
    verificationCode: '驗證碼',
    user: '帳號',
    password: '密碼',
    confirmPassword: '確認密碼',
    email: '郵箱',
    remarks: '備註',
    mobile: '手機號',
    timeBase: 'YYYY年MM月DD日 HH:mm:ss',
    tips: '提示',
    legend: '圖例',
    layer: '圖層',
    waitData: '等待接收資料...',

    startTest: '開始測試',
    pauseTest: '暫停測試',
    xyView: 'XY視圖',
    xzView: 'XZ視圖',
    yzView: 'YZ視圖',
    threeDChart: '三維圖',

    startVerify: '開始驗證',
    pauseVerify: '暫停驗證',
    deviceNodeReady: '設備各節點安裝到位',
    ivt: '安裝驗證',
    ivtTitle: '安裝回饋圖',
    ivtXAxis: '安裝傾斜角（度）',
    ivtYAxis: '深度（米）',
    ivtUninstall: '安裝未到位',
    ivtInstalled: '安裝到位',
    ivtThreshold: '安裝臨界值',

    readTime: '讀取時間',

    originalReferencePoint: '基準點',

    remoteSensing: '遙感圖',
    topographic: '地形圖',
    traffic: '交通圖',
    dataEmpty: '數據為空',
    projectDeviceResearch: '設備考證表',
    editThreshold: '編輯閾值',
    initCollection: '初值',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    waitingDev: '正在開發中，敬請期待！',
  },
  // 路由
  router: {
    Home: '首頁',
    managementConsole: '管理主控台',
    projects: '項目列表',
    ProjectIndex: '項目列表',
    monitoringData: '監測資料',
    commonMonitor: '獨立監測',
    groupMonitor: '組合監測',
    alarmRecord: '報警記錄',
    reports: '資料包表',
    exportReport: '匯出報表',
    downloadReport: '下載報表',
    projectConsole: '專案管理',
    deviceConsole: '設備管理',
    systemManagement: '系統管理',
    corporateInformation: '企業資訊',
    corporationConsole: '企業資訊',
    contacts: '企業联系人管理',
    config: '坐标系管理',
    contact: '企業联系人',
    accountManagement: '帳號管理',
    userConsole: '帳號管理',
    rolePermissions: '角色許可權',
    roleConsole: '角色許可權',
    groupManagement: '分組管理',
    userGroupConsole: '分組管理',
    collapseSidebar: '折疊側邊欄',
    profile: '個人中心',
    alerts: '報警記錄',
    pushStrategy: '數據推送',
    pushStrategyConsole: '數據推送',
    CommandDebug: '命令調試',
    operationLog: '操作日誌',
  },
  // 公用元件的內容
  components: {
    timingDiagram: '時序圖',
    deleteObject: '刪除對象',
    bimUploadStatusFinishLabel: '已上傳',
    bimUploadStatusFinishLink: '發起轉換',
    bimUploadStatusConvertingLabel: '正在轉換',
    bimUploadStatusConvertingLink: '更新進度',
    bimUploadDeleteSourceFiles: '刪除原始檔案',
    bimConvertSuccess: '已轉換',

    imgLocationInputFromTop: '距離頂部',
    imgLocationInputFromLeft: '距離左邊',
    imgLocationInputPictureAnnotation: '圖片標注',
    imgLocationInputPoint: '標記點',

    locatePlaceholder: '輸入位址進行定位',
    markedHere: '標注在此',

    formLabel: '關聯測點',
    connected: '已關聯',
    unConnected: '未關聯測點',
    associatedPoint: '關聯測點',
    addPoint: '添加標記',
    deletePoint: '刪除標記',
    savePoint: '保存操作',

    // ConfInput組件
    confInput: {
      ids: {
      // 配置網路
        TCP: '標準網路',
        // 配置採集策略
        CommandCollect: '平臺下發採集',
        UploadCollect: '設備主動上傳',
        NoCollect: '停止採集',
      },
      // 配置網路
      networkConf: {
        register: '網路識別碼',
      },
      // 配置採集策略
      collectConf: {
        interval: {
          label: '採集間隔',
        },
        start: '開始時間',
        end: '結束時間',
        retry: {
          label: '重試次數',
          unit: '次',
        },
        delay: {
          label: '重試間隔',
          unit: '秒',
        },
      },
    },
  },
  tableColumn: {
    bimUploadName: '檔案名',
    bimUploadTranslateStatus: '轉換狀態(已上傳/轉換中/已轉換)',
    time: '採集時間',
    node: '首節點',
    voltage: '電壓（V）',
    temperature: '溫度（°C）',
    alertTime: '報警時間',
    type: '類型',
    level: '等級',
    status: '狀態',
    alarmItem: '報警項',
    alarmValue: '報警值',
    alarmReason: '報警原因',
    alarmLocation: '報警定位',
    reportTime: '報表時間',
    name: '名稱',
    alertType: '報警類型',
    structureId: '關注結構物',
    alertLevel: '報警等級',
    mobileList: '簡訊清單',
    mobileConfirmList: '險情確認簡訊清單',
    mobileVoiceListField: '手机雲因提醒列表',
    emailList: '郵箱列表',
    enable: '啟用狀態',
    memberName: '帳號',
    displayName: '昵稱',
    memberStatus: '活動狀態',
    card: '設備配置',
    card3: '位置信息',
    card4: '搬站迁移',
    manufacturer: '製造商',
    deviceName: '設備名稱',
    deviceModel: '設備型號',
    serialNumber: '序號',
    fileName: '觀測數據檔名',
    fileSize: '數據文件大小',
    fileLastTime: '觀測資料檔案更新時間',
    isMounted: '關聯狀態',
    card2: '通道配置',
    accType: '帳號類型',
    roleName: '角色名稱',
    roleNote: '角色描述',
    groupName: '分組名稱',
    groupNote: '分組描述',
    pushType: '推送策略',
    pushEnable: '推送開關',
    pushInterval: '推送間隔',
    ruleNote: '規則描述',
    pushUrl: '推送介面',
    jobName: '任務名稱',
    jobOptions: '任務參數',
    jobNextRunAt: '預計執行時間',
    userRole: '帳號角色',
    config: '配置',
    xOffset: '水平位移x',
    yOffset: '水平位移y',
    zOffset: '縱向位移Z',
    hConvergence: '橫向收斂',
    vConvergence: '縱向收斂',
    archSettlement: '拱頂沉降',
    roadbedSettlement: '道床沉降',
    differentialSettlement: '差異沉降',
    chord: '弦長',
    chordDiff: '弦長變化',
  },
  // 表單相關標籤/placeholder/options
  form: {
    structureName: '結構物名稱',
    structureAddress: '結構物位址',
    displayMode: '展示方式',
    structurePicture: '結構物圖片',
    displayTypeOptions: {
      MAP: '地圖展示',
      IMG: '圖文展示',
      BIM: 'BIM模型展示',
    },
    measurementPointType: '測點類型',
    measuringPointNumber: '測點編號',
    measuringPointImage: '測點圖片',
    monitoringEquipment: '監測設備',
    collectionEquipment: '採集設備',
    transmissionDevice: '傳輸設備',
    collectMode: '採集方式',
    uploadCollect: '數據上傳',
    commandCollect: '平臺下發採集',
    noCollect: '資料直通，無需採集（適用於視頻監控）',
    selectTestType: '選擇測試類型',
    testOptions: {
      'adm-test': '陣列位移計測試',
      'adm-install-test': '陣列位移計下壓安裝測試',
      'sdm-test': '傾角測試',
      'sdmx-test': '振動測試',
      'sdmpro-test': '傾角振動測試',
      'gps-sdmpro-test': '單點姿態定位測試',
    },

    pointPlaceholder: '輸入測點',
    timeLimit: '時間範圍',
    intervals: '時間間隔',
    measurementType: '測數值型別', // TODO
    measurementTypeOptions: {
      observations: '觀測值',
      changeValue: '變化值',
    },
    gnssType: '结果类型', // TODO
    gnssTypeOptions: {
      GNSS: 'GNSS',
      GNSS2: 'GNSS2',
      GNSS3: 'GNSS3',
      GNSS4: 'GNSS4',
      GNSS5: 'GNSS5',
    },
    ObField: '觀測屬性',
    ObNode: '觀測節點',
    pointNumber: '測點編號', // TODO
    enterpriseID: '企業ID',
    deviceType: '設備類型',
    manufacturer: '製造商',
    deviceName: '設備名稱',
    deviceModel: '設備型號',
    serialNumber: '序號',
    isSensor: '感測器（探頭、棱鏡）',
    withAcquisitionFunction: '具備採集功能',
    withTransmissionFunction: '具備傳輸功能',
    numberOfChannels: '通道數',
    networkConfiguration: '網路配置',
    collectorType: '採集器類型',
    companyName: '企業名稱',
    companyNamePlacecholder: '請輸入企業名稱',
    logo: '企業Logo',
    favicon: '網頁圖示',
    platformName: '平臺名稱',
    platformNamePlacecholder: '請輸入平臺名稱',
    address: '地址',
    addressPlacecholder: '請輸入位址',
    slogan: '標語',
    sloganPlacecholder: '請輸入標語',
    domainName: '功能變數名稱',
    domainNamePlacecholder: '請輸入功能變數名稱',
    copyrightInformation: '版權資訊',
    copyrightInformationPlacecholder: '請輸入版權資訊',
    loginPageBackground: '登錄頁背景',
    WechatAppletLoginPageBackground: '小程式登入頁背景',
    WechatAppletBasePageBackground: '小程式首頁圖片',
    WechatAppletAboutIntroduce: '小程式關於我們介紹',
    WechatAppletContacts: '小程式連絡人',
    WechatAppletContactsPhone: '小程式連絡人電話',
    WechatAppletContactsMailbox: '小程式連絡人郵箱',
    remarkInformation: '備註信息',
    displayName: '昵稱',
    roles: '分配角色',
    userGroups: '加入分組',
    rolePlacecholder: '請選擇角色',
    groupPlaceholder: '請選擇分組',
    activeStatusOptions: {
      true: '禁用',
      false: '活動',
    },
    groupName: '分組名稱',
    groupNote: '分組描述',
    groupRoles: '分配角色',
    groupUsers: '添加成員',
    rolesPlaceholder: '請選擇角色',
    usersPlaceholder: '請選擇分組成員',
    avatar: '頭像',
    namePlacecholder: '請輸入帳號',
    displayNamePlacecholder: '請輸入昵稱',
    mobilePlacecholder: '請輸入手機號碼',
    emailPlacecholder: '請輸入郵箱',
    oldPassword: '原始密碼',
    newPassword: '新密碼',
    newPasswordConfirmation: '確認新密碼',
    oldPasswordPlaceholder: '請輸入原密碼',
    newPasswordPlaceholder: '請輸入新密碼',
    confirmationPlaceholder: '請再次輸入新密碼',
    pushtype: '推送類型',
    pushurl: '推送介面',
    pushinterval: '推送間隔',
    pushenable: '策略開關',
    pushdes: '規則描述',
    pushmeasuringPointIds: '測點列表',
    badNodes: '故障節點',
    hiddenNodes: '隱藏節點',
    antiSettle: '下沉修正',
    isIndep: '獨立座標',
    coorSystem: '座標標籤',
    profileChart1LMetric: '剖面圖左圖橫軸指向',
    profileChart1RMetric: '剖面圖右圖橫軸指向',
    profileChart1LNoteL: '剖面圖左圖左區備註',
    profileChart1LNoteR: '剖面圖左圖右區備註',
    profileChart1RNoteL: '剖面圖右圖左區備註',
    profileChart1RNoteR: '剖面圖右圖右區備註',
    profileChart3CoorSystem: '軌跡圖坐標系',
    handCoorSystemOptionsR: '右手坐標系',
    handCoorSystemOptionsL: '左手坐標系',
    profileChart3NoteL: '軌跡圖左區備註',
    profileChart3NoteR: '軌跡圖右區備註',
    formulaType: '公式類型',
    formulaTypeSystem: '系統公式',
    formulaTypeCustom: '自訂',
    sysFormula: '選擇公式',
    insideDiameter: '內徑',
    insideDiameterP: '請輸入測斜管內直徑，單位毫米',
    selectMeasuringPoint: '選擇測點',
    slaveMeasuringPoint: '子測點',
    rdmTime: '測量時間',
    rdmFixOptions: {
      unfix: '矯正前',
      fix: '矯正後',
    },
    pointPosition: '斷面點位',
    sectionChord: '斷面弦長',
  },
  formRules: {
    name: '姓名',
    stringRequire: '不能為空，請輸入',
    numberRequire: '不能為空，請輸入數值',
    length6to20:'請限制在6至20個字元以內',
    length20: '請限制在20個字元以內',
    length50: '請限制在50個字元以內',
    mobileRequire: '手機號不能為空',
    mobile: '手機格式不正確',
    email: '郵箱格式不正確',
    passwordRequire: '密碼不能為空',
    passwordLength6: '密碼長度不能低於6位元',
    domainRequire: '企業首碼不能為空',
    contactName: '联系人姓名不能為空',
    domain: '企業首碼格式不正確',
    ip: 'IP位址格式不正確',
    point: '掛載點不能為空',
    collectorChannel: '採集通道參數格式錯誤',
    corporationName: '企業名稱不能為空',
    corporationTitle: '雲平臺標題不能為空',
    userGroupName: '分組名稱不能為空',
    roleRuleName: '角色名稱不能為空',
    projectName: '項目名稱不能為空',
    projectAddress: '請輸入專案位址',
    deviceMeasurement: '測量類型不能為空',
    deviceCategory: '設備類別不能為空',
    deviceType: '設備類型不能為空',
    deviceManufacturer: '製造商不能為空',
    deviceName: '設備名稱不能為空',
    deviceModel: '設備型號不能為空',
    deviceModelPreg: '設備型號：',
    deviceSncode: '序號不能為空',
    deviceCollectorType: '採集器類型不能為空',
    deviceCoorSystem: '請選擇座標標籤',
    deviceProfileChart1LMetric: '請選擇指向',
    deviceProfileChart1RMetric: '請選擇指向',
    zrzybIp: 'IP不能為空',
    zrzybPort: '埠號不能為空',
    zrzybDeviceId: 'MQTT用户名不能為空',
    zrzybDeviceKey: 'MQTT密码不能為空',
    zrzybDeviceNumber: '監測序號不能為空',
    zrzybDeviceNumberNode: '該設備監測序號數量與節點數量不一致，請核對',
    zrzybDeviceNumberNull: '監測序號不能為空或重複，請核對',
    zrzybIsPush: '請選擇是否開啟推送',
    deviceTypeRule: '請選擇設備類別',
    mpAttrType: '請選擇指標',
    mpAttrName: '指標別名不能為空',
    mpAttrDeviceId: '關聯設備不能為空',
    mpAttrInterval: '測量間隔不能為空',
    mpName: '測點名稱不能為空',
    mpStructureId: '請選擇結構物',
    mpMeasuringDeviceId: '請選擇測量設備',
    mpDtuId: '請關聯傳輸設備',
    structureName: '結構物名稱不能為空',
    structureType: '結構物類型不能為空',
    bimName: 'BIM模型名稱不能為空',
    bimAddress: 'BIM模型位址不能為空',
    measurement: '請選擇監測類型',
    formulaType: '請選擇公式類型',
    computedField: '請選擇轉換屬性',
    formula: '公式不能為空',
    sysFormula: '系統公式不能為空',
    thresholdRule: '閾值區間格式錯誤',
    thresholdField: '請選擇監測屬性',
    thresholdType: '請選擇測數值型別',
    thresholdVoltage: '請輸入電壓閾值',
    thresholdLost: '請輸入丟失容限',
    alertRuleType: '請選擇報警類型',
    alertRuleMobileList: '短信列表中有不規則手機號',
    alertRuleEmailList: '郵寄清單中有不規則郵箱',
    projectId: '請選擇項目',
    pushStrategyType: '請選擇推送類型',
    pushStrategyUrl: '請填寫推送介面',
    pushStrategyInterval: '請選擇推送間隔',
    measuringPointIds: '請選擇測點',

    structureGnsstaskName: '請輸入解算任務名',
    structureGnssAgreementCode: '請選擇設備接入協議',
    structureGnssBaseStation: '請選擇基準站',
    structureGnssFilteringTime: '請輸入濾波時長',
    structureGnssFtTiNoZero: '濾波時長及任務間隔不能為0',
    structureGnssTaskInterval: '請輸入解算任務間隔',
    structureSwitch: '切換結構物',
    pointFilter: '過濾測點',
    sncodeExist1: '序列號 ',
    sncodeExist2: ' 已被使用，如有疑問請聯繫管理員',
    registerExist1: '網絡識別碼 ',
    registerExist2: ' 已被佔用，如有疑問請聯繫管理員',
  },

  msg: {
    1: '是否把 {time} 採集的資料作為當前測點的初始值？',
    2: '是否刪除 {time} 採集的資料？',
    3: '該操作將把此次報警狀態更新為 "{status}" 且不能再更改，請確認？',

    4: '此操作將永久刪除該策略, 是否繼續?',
    5: '已取消刪除',
    6: '是否確定修改該策略?',
    7: '已取消修改',

    8: '電壓閾值，設備電壓低於設置值將觸發設備健康報警（欠壓）',
    9: '丟失容限，連續出現設置次數的採集丟失將觸發設備健康報警（採集異常）',
    10: '取消已掛起的命令任務 {name} ？',
    11: '成功更新 {count} 個監測設備的測值公式',
    12: '軌跡更新',
    13: '是否確定開啟監控？',
    14: '是否確定關閉監控？',
    title1: '操作提示',
    msg1: '保存測點標記操作',
    associatedMeasuringPoint: '存在未關聯測點的標記，請全部關聯',
    createThresholdSucess: '成功創建 {createCount} 個測量欄位閾值配置，更新 {updateCount} 個測量欄位閾值配置',
    bimUpload1: '將文件拖到此處，或',
    bimUpload2: '點擊上傳',
    bimUpload3: '支持檔案格式rvt、rfa、dwg、dxf、skp、ifc、dgn、obj、stl、3ds、dae、ply、igms、zip、fbx、dwf、nwd、osgbzip，大小限制10240M',
    bimUpload4: '請確認刪除BIM模型！',
    bimUpload5: '上傳原始檔案失敗',
    bimUpload6: '原始檔案上傳失敗',
    repeatPhone: '手機號已存在',
  },
  error: {
    2: '當前測點關聯的陣列位移計未更新節點號',
    4: '當前公式包含非法輸入，請按提示輸入',
    5: '當前公式不完整...',
    6: '測點關聯監測設備類別不正確',
    7: '載入結構物選項失敗',
    8: '載入監測類型選項失敗',
    9: '載入設備類別失敗',
    10: '載入監測欄位失敗',
    11: '載入測點選項失敗',
    12: '成功更新 {count} 個監測設備的健康閾值',
    13: '請上傳圖片檔!',
    14: '上傳圖片大小不能超過 200KB!',
    15: '測點資訊錯誤，無法獲取測點軌跡',
    50: '確認删除此解算任務？',
    lessPointToast: '至少選擇一個測點查詢',
    noMeasuringDevice: '請規範操作，重新查詢或刷新頁面',
    noInitCollection: '設備未設置初值',
    noCollections: '當前時間範圍內沒有採集資料',
    rdmNoConfig: '測斜儀配置資訊不完整，請先進行參數配置',
    noEqualToExpectedNodeCount: '設備節點數 ({nodeCount}) 不等於期望節點數 ({expectedNodeCount}) ，請檢查設備後重排節點',
    deviceDisConnect: '請在設備聯網後進行操作',
    gnssBaseStationNoData: 'GNSS基準站無監測數據',
    sgbjStr: '請填寫報警內容',
    sgbjInterval: '请填写发送频率',
  },
  // 監測屬性
  fields: {
    voltage: '電壓',
    temperature: '溫度',
    x: 'X座標',
    y: 'Y座標',
    z: 'Z座標',
    azi: 'Azi',
    gx: 'X加速度',
    gy: 'Y加速度',
    gz: 'Z加速度',
    anglex: 'X角度',
    angley: 'Y角度',
    anglez: 'Z角度',
    angleh: '水平角',
    anglev: '垂直角',
    slantdist: '斜距',
    tiltx: 'X傾斜',
    tilty: 'Y傾斜',
    e: '東向座標',
    n: '北向座標',
    u: '天向座標',
    ve: '東向座標日变形速率',
    arctanE: '東向座標切向角',
    vn: '北向座標日变形速率',
    arctanN: '北向座標切向角',
    vu: '天向座標日变形速率',
    ven: '平面日变形速率',
    venu: '三维日变形速率',
    arctanU: '天向座標切向角',
    xyDisplacement: '平面位移量',
    xyDisplacement2: '平面距離',
    xyzDisplacement: '三維位移量',
    xyzDisplacement2: '三維距離',
    differenceAge: '差分期齡',
    idmD: '水準位移', // 圖像位移測量儀屬性
    idmS: '沉降',
    f: '頻率',
    t: '溫度',
    i: '電流',
    liquidlevel: '液位值',
    deltah: '液位變化量',
    settle: '沉降量',
    displacement: '位移',
    mod: '頻模',
    pressure: '滲壓',
    waterlevel: '水位',
    waterlevel1: '水位',
    crack: '裂縫',
    humidy: '濕度',
    steel: '應力', // 鋼筋計
    strain: '應變',
    stress: '應力', // 應變計應力
    custom: '自訂',
    dataLost: '資料丟失',
    dataRepeat: '資料重複',
    lowVoltage: '欠壓',
    axialforce: '載荷力',
    soilpressure: '土壓應力',
    pt: '累計降雨量（探頭值）',
    pd: '日降雨量',
    pj: '當前降雨量',
    ph: '小時降雨量',
    p24: '前0~24小時雨量',
    p48: '前24~48小時雨量',
    p72: '前48~72小時雨量',
    pc: '前3天降雨量',
    pcc: '前0~24時雨量值*1+前24~48時雨量值*0.8+前48~72時雨量值*0.5',
    rainfall: '累計降雨量',
    winPressure: '气压',
    windDir: '风向',
    windSpeed: '风速',
    flowrate: '流速',
    depth: '深度',
    a: 'A',
    a0: 'A0',
    a180: 'A180',
    b: 'B',
    b0: 'B0',
    b180: 'B180',
    angle: '扭角',
    angle0: '0回次扭角',
    angle180: '180回次扭角',
    xOffset: '橫向位移X',
    yOffset: '橫向位移Y',
    zOffset: '縱向位移Z',
    hConvergence: '橫向收斂',
    vConvergence: '縱向收斂',
    archSettlement: '拱頂沉降',
    roadbedSettlement: '道床沉降',
    differentialSettlement: '差異沉降',
    chord: '弦長',
    chordDiff: '弦長變化',
  },
  // 單位
  units: {
    v: 'V',
    times: '次',
    m: 'm',
    mm: 'mm',
    frequency: '次',
    hour: '小時',
    minute: '分鐘',
    second: '秒',
    deg: '度',
  },
  // 動態參數集合
  dync: {
    accType: {
      System: '系統帳號',
      Admin: '企業帳號',
      Normal: '普通帳號',
    },
    chartType: {
      overview: '最新狀態',
      'adm-chart': '資料圖表',
      'tdm-chart': '資料圖表',
      'common-chart': '資料圖表',
      'gnss-realtime-chart': 'GNSS即時資料圖表',
      'gnss-chart': '資料圖表',
      'adm-data': '資料表格',
      'common-data': '資料表格',
      camera: '監控畫面',
      deviceTrajectory: '設備軌跡',
      SectionOffset: '斷面位移',
      SectionConvergence: '斷面收斂',
      SectionSettlement: '斷面沉降',
      SectionChord: '任意弦長',
    },
    chartTypeOptions: {
      profile: '剖面圖',
      componentMap: '分量圖',
      orientationMap: '方點陣圖',
      ThreeDimensionalMap: '三維圖',
      horizontalChart: '水準沉降圖',
      circularChart: '設備環形圖',
      rdmPipeChart: '本次管型圖',
      rdmChangeChart: '本次變化圖',
      rdmAccChangeChart: '累計變化圖',
      rdmFixRChart: '本次扭角圖',
      rdmTempChart: '本次溫度圖',
    },
    devicetype: {
      Measuring: '測量設備',
      Collector: '採集設備',
      DTU: '傳輸設備',
    },
    collectorType: {
      ADM: '華思ADM採集器',
      HDA2: '華思振弦式數采',
      HDA3: '華思電流式數采',
      SDM: '華思點式數采',
    },
    structureType: {
      Bridge: '橋樑',
      FoundationPit: '基坑',
      Slope: '邊坡',
      Dam: '大壩',
      Tunnel: '隧道',
      Tailings: '尾礦庫',
      Building: '建築物',
      Tower: '鐵塔',
      SpecialEquipment: '特種設備',
      WeatherStation: '氣象站',
      PipeNetwork: '市政管網',
    },
    measuringType: {
      ALL: '全部',
      DeepDisplacement: '深部位移',
      SurfaceDisplacement: '表面位移',
      Waterlevel: '水位',
      Waterlevel1: '水位',
      Tilt: '傾斜',
      Vibration: '振動',
      Crack: '裂縫',
      Track: '軌跡',
      DBCJ: '地表沉降',
      ZCYL: '應力應變',
      SGBJ: '聲光報警',
      AxialForce: '軸力監測',
      StructuralDeformation: '結構變形',
      Camera: '視頻監控',
      Temperature: '溫度',
      Rainfall: '雨量',
      Flow: '流量',
      Moisture: '濕度',
      SoilPressure: '土體壓力',
      SoilMoisture: '墒情',
      Displacement: '位移',
      WindSpeed: '風速',
      WindDirection: '風向',
      SlopeVibration: '邊坡振動',
      HorizontalTilt: '水準傾斜',
      SupportingStructureDeformation: '支護結構變形',
      GNSSReferenceStation: 'GNSS基準站',
      GNSSMonitoringStation: 'GNSS監測站',
      GroundwaterLevel: '地下水水位',
      PhreaticLine: '浸潤線',
      ClearanceConvergence: '淨空收斂',
      PoreWaterPressure: '孔隙水壓',
      Deflection: '撓度',
      DebrisFlow: '泥石流',
      SupportingAxialForce: '支撐軸力',
      AnchorForce: '錨索索力',
    },
    deviceCategory: {
      ADM: '陣列位移計',
      HDA2: '振弦式滲壓計',
      HDA3: '電流式水位計',
      HDA_HS: '华思水位計',
      Crack: '振弦式測縫計',
      SDM: '傾角計',
      SDMX: '振動計',
      SDMPRO: '傾角振動計',
      TDM: '軌跡計',
      HSL: '靜力水準儀',
      STRAIN: '振弦式應變計',
      Steel: '振弦式鋼筋計',
      Anchor: '振弦式錨索計',
      AFM: '振弦式軸力計',
      SPM: '振弦式土壓力計',
      SHM: '土壤濕度溫度感測器',
      Station: '全站儀',
      GNSS: 'GNSS',
      Camera: '攝像頭',
      SGBJ: '聲光報警器',
      RDM: '測斜儀',
      IDM: '圖像位移測量儀',
      Rain: '雨量計',
      Flow: '流量計',
    },
    alarmStatus: {
      Pending: '待處理', // 待處理
      Notice: '已通知', // 已通知
      Confirm: '險情確認', // 險情確認
      ConfirmNotice: '險情確認已通知', // 險情確認
      FalseAlarm: '誤報', // 誤報
      Restore: '恢復正常', // 恢復正常
    },
    timeOptions: {
      hour1: '最近一小時',
      day1: '最近一天',
      week1: '最近一周',
      month1: '最近一月',
      halfYear: '最近半年',
      year1: '最近一年',
      thisHour1: '最近這小時',
      thisDay1: '最近這天',
      thisWeek1: '最近這周',
      thisMonth1: '最近這月',
      thisHalfYear: '最近這半年',
      thisYear1: '最近這年',
    },
    intervalsText: {
      seconds0: '无间隔',
      seconds1: '每1秒',
      seconds5: '每5秒',
      seconds10: '每10秒',
      seconds30: '每30秒',
      minute1: '每1分鐘',
      minute2: '每2分鐘',
      minute5: '每5分鐘',
      minute10: '每10分鐘',
      minute15: '每15分鐘',
      minute30: '每30分鐘',
      hour1: '每1小時',
      hour2: '每2小時',
      hour6: '每6小時',
      hour12: '每12小時',
      day1: '每1天',
      day2: '每2天',
      day5: '每5天',
      day7: '每7天',
      day10: '每10天',
      day20: '每20天',
      day30: '每30天',
    },
    tScope: {
      Corporation: '企業',
      User: '帳號',
      UserGroup: '分組',
      Role: '角色',
      Project: '項目',
      Structure: '結構物',
      MeasuringPoint: '測點',
      Device: '設備',
      Report: '報告',
      AlertRule: '報警規則',
      PushRule: '數據推送',
      Alert: '報警記錄',
    },
    tAction: {
      Create: '創建',
      Delete: '刪除',
      Retrieve: '查看',
      Update: '更新',
    },
    tDevType: {
      Measuring: '監測設備',
      Collector: '採集設備',
      DTU: '傳輸設備',
    },
  },

  // 登錄頁的內容
  login: {
    login: '登錄',
    register: '註冊',
    username: '用戶名',
    zh: '简体中文',
    en: 'English',
    zhTW: '繁體中文',
    rememberMe: '記住我',
    forgetPassword: '忘記密碼',
    loading: '登錄中...',
    slogan: '因為專注 所以專業',
    start: '開始',
    accountInformation: '帳號信息',
    companyInformation: '企業資訊',
    ending: '完成',
    phone: '手機號碼',
    domain: '企業首碼',
    companyName: '企業名',
    cloudPlatformTitle: '雲平臺標題',
    copyrightInformation: '版權資訊',
    previous: '上一步',
    loginPage: '登錄頁面',
    backRegisterPage: '返回註冊頁面',
    verificationCodePlaceholder: '請輸入驗證碼',
    verifySvgCodePlaceholder: '請輸入圖片驗證碼',
    verifyPhoneCodePlaceholder: '請輸入簡訊驗證碼',
    usernamePlaceholder: '請輸入用戶名',
    passwordPlaceholder: '請輸入密碼',
    validatePasswordDifferent: '兩次輸入密碼不一致',
    resetPsd: '重置密碼',
    verify: '驗證碼', // TODO
    verifyPhone: '手機驗證碼', // TODO
    verifySvg: '圖片驗證碼', // TODO
    usernameR: '請填寫用戶名',
    passwordR: '請填寫密碼',
    phoneR: '請填寫手機號碼',
    phoneR2: '請填寫正確的手機號碼',
    verifyR: '請填寫驗證碼',
    formR: '請把表單填寫完整後繼續！',
    getVerify: '獲取驗證碼',
    returnLogin: '返回登錄',
    submit: '提交',

    resetSuccessTit: '重置密碼成功',
    resetSuccessP: '重置密碼成功，密碼將會以短信形式發送到您的手機。',
  },
  // 首頁
  home: {
    projectStatusStatistics: '專案狀態統計',
    amount: '數目',
    structureStatus: '結構物狀態統計',
    pointStatus: '測點狀態統計',
    alarmProcessing: '報警處理統計',
    projectStatus: '狀態',
    projectLevel: ['正常', '黃色報警', '橙色報警', '紅色報警'],
    healthStatusList: ['正常', '設備欠壓', '資料丟失', '資料重複'],
    healthStatus: {
      health: '正常',
      lowVoltage: '設備欠壓',
      dataLost: '資料丟失',
      dataRepeat: '資料重複',
    },
    projectNoExist: '項目不存在',
    historyAlarm: '歷史報警',
    projectName: '項目名稱',
    projectAddress: '項目位址',
    structuresTotal: '結構物總數',
    pointTotal: '測點總數',
    associatedDeviceTotal: '關聯設備總數',
    projectInfo: '專案資訊', // TODO
    deviceStatus: '設備狀態統計',
    monitoringOverview: '監測概況',
    alertStat: '報警狀態',
    monitoringTableHeader: [
      '結構物',
      '測點',
      // '設備號',
      // '設備電壓',
      '監測項',
      '最大變化',
      '累计位移',
      '日變化速率',
      '最近採集',
      '報警狀態',
      '報警值',
    ],
    alarmOverview: '報警概況',
    tableHeader: ['結構物', '測點', '報警事件'],
    defaultIntroduction: '該專案還未填寫備註資訊，請在專案管理中填寫。',
    total: '總量',
    goBack: '上一級',
  },
  // 檢測資料
  monitor: {
    preview: '數據總覽',
    createStructure: '請創建結構物',
    selectChartType: '選擇圖表類型',
    viewNode: '查看節點',
    profileChart: '剖面圖',
    FIGTimingMeasuring: '測點時序圖',
    timeValueChart: '觀測資料過程線圖',
    nodeValueChart: '節點資料過程線圖',
    nodeTrackChart: '節點軌跡圖',
    admPropChart: '分量圖',
    horizontalChart: '水準沉降圖',
    circularChart: '環形圖',
    displacementChart: '變形量圖',
    coordChart: '方位觀測值圖',
    coordChangeChart: '方位變化值圖',
    vibrationChart: '振動資料過程線圖',
    GNSSChart: 'GNSS資料過程線圖',
    pipeChart: '管型圖',
    rdmTempChart: '本次溫度圖',
    rdmFixrChart: '本次扭角圖',
    rdmChangeChart: '本次變化圖',
    rdmAccChangeChart: '累計變化圖',
    initTime: '初始時間',
    initData: '初始數據',
    componentTrendGraph: '分量趨勢圖',
    weight: '分量',
    WarningLine: '警戒線',
    level1: '壹級',
    level2: '贰級',
    level3: '叁级',
    takePictures: '拍照',
    playRecPlayer: '切換直播或錄像',
    more: '載入更多',
    HistorySnapshot: '歷史抓拍',
    RecPlayer: '錄像回放',
    LivesPlayer: '視頻直播',
    controlPanel: '摄像头控制台',
    sgbjControlPanel: '声光报警控制台',
    livePlayerLoading: '正在獲取accessToken...',
    setInitValue: '設為初值',
    deleteRecord: '刪除記錄',
    batchDeletion: '批量刪除',
    collectionDetails: '採集詳情',
    time: '時間',
    node: '節點',
    elevation: '高程',
    depth: '深度',
    displacement: '位移',
    distance: '距離',
    settlement: '沉降',
    changeValue: '變化量',
    NbyE: '北偏東',
    offset: '偏移',
    A: 'A方向',
    B: 'B方向',
    E: '東向',
    N: '北向',
    NodeOrientationData: '節點方位資料',
    zoom: '顯示比例',
    showSection: '顯示剖面',
    ratioOptions: {
      ratio: '等比例',
      adaptive: '自我調整',
    },
    profileOptions: {
      view3d: '三維視圖',
      XYPlaneABPlane: 'XY 面（AB 面）',
      XZPlaneAZPlane: 'XZ 面（AZ 面）',
      YZPlaneBZPlane: 'XY 面（BZ 面）',
    },
    refreshStatus: '刷新狀態',
    caustomReportColumns: '定制報告列',
    customColumn: '定制列',
    nodePlaceholder: '請選擇節點',
    dialogDeleteTitle: '批量刪除方式的選擇',
    chooseDeleteTime: '刪除的時間段選擇',
    deleteCollotion: '請先選擇要刪除的採集資料',
    deleteByTime: '按時間段刪除',
    deleteBySelection: '按選中的採集資料刪除',
    chartSetting: '圖表屬性設置',
    xAxis: '橫軸',
    yAxis: '縱軸',
    LXAxis: '左圖橫軸',
    RXAxis: '右圖橫軸',
    chartInterval: '列寬',
    max: '最大值',
    min: '最小值',
    useSetting: '應用',
    common: '其他設置',
    showSymbol: '顯示標記圖形',
    trendPrediction: '趨勢預測',
    multiIndicatorEarlyWarning: '多指標預警',
    sgbj:{
      status:{
        being:'發送中',
        waiting:'等待中',
        finish:'完成',
        cancel:'取消',
      }
    }
  },
  // 報警記錄
  alerts: {
    alarmRecord: '報警記錄',
    alarmType: '報警類型', // TODO
    alarmTypeOptions: {
      measuredValueAlarm: '測值報警',
      equipmentFailure: '設備故障',
    },
    status: '狀態',
    level: '報警等級',
    levelOptions: ['-', '黃色報警', '橙色報警', '紅色報警'],
    alarmDetail: '報警詳情',
    ConfirmationDanger: '險情確認',
    riskExclusion: '險情排除',
    alertDetail: {
      alarmID: '報警ID',
      monitoringAttr: '監測屬性',
      triggerInterval: '觸發區間',
      SMScontent: '短信內容',
      email: '郵件內容',
      noticeList: '通知名單',
      mailingList: '郵件名單',
      levelAlarm: '級報警',
    },
    reason: {
      dataLost: '資料丟失超過',
      lowVoltage: '電壓低於',
      value: '測值落在閾值區間',
    },
  },
  // 報表下載
  report: {
    exportReport: '匯出報表',
    downloadReport: '下載報表',
    reportType: '報表類型',
    reportOption: {
      exportData: '數據匯出',
      measuringPointReport: '測點報告',
      projectReport: '專案報告',
      projectDeviceResearchReport: '專案設備考證表',
    },
    download: '下載',
    export: '匯出',
    delete: '刪除報表',
    confirmHandler: '請再次確認您的操作！',
    reportStatus: {
      Done: '完成',
      Pending: '正在生成',
      Error: '錯誤',
    },
    template: '報表範本',
    ts: {
      project: '项目监测报表',
      day: '監測報表',
      SectionDeformation: '斷面形變報表',
    },
    period: '報表時間',
  },
  // 專案管理
  project: {
    siteMonitoring: '測點監控',
    waitPicture: '專案圖片待上傳',
    newProject: '新建項目',
    newSubsidiary: '新建子公司',
    allProject: '所有項目',
    structureType: '結構物類型',
    measurement: '監測類型',
    structureDetails: '結構物詳情',
    pointDetails: '測點詳情',
    projectDetails: '項目詳情',
    createStructure: '創建結構物',
    createPoint: '創建測點',
    createProject: '創建項目',
    createSubsidiary: '创建子公司',
    projectInfo: '專案資訊',
    deviceTopology: '設備拓撲',
    convert: '測值轉換',
    alarmThreshold: '報警閾值',
    equipmentHealth: '設備健康',
    alarmManagement: '報警管理',
    memberManagement: '成員管理',
    updateRecord: '更新記錄',
    deleteProject: '刪除項目',
    deleteTitle: '刪除專案，專案下的結構物及測點數據將關聯刪除，請謹慎操作！',
    projectName: '項目名稱',
    address: '項目位址',
    coordinate: '經緯座標',
    picture: '專案圖片',
    conversionFormulaTitle: '配置測值轉換公式',
    conversionAttributes: '轉換屬性',
    conversionFormula: '轉換公式',
    conversionFormulaPlaceholder: '請輸入有效的公式',
    conversionFormulaTip: {
      show: '顯示提示',
      hide: '隱藏提示',
      tip1: '請使用英文輸入法。',
      tip2: {
        1: '可輸入數位',
        2: '小數點',
      },
      tip3: {
        1: '可輸入以下運算子：加減乘除',
        2: '括弧',
        3: '平方',
        4: '開方',
        5: '正弦',
      },
      monitoringAttributes: '可使用監測屬性',
      eg: '示例',
      text: '表示求監測屬性{text}的平方',
    },
    appPoint: '應用測點',
    noUsePoint: '沒有相關測點',
    configThreshold: '配置測點報警閾值',
    monitoringAttributes: '監測屬性',
    monitoringAttributesPlaceholder: '請選擇監測屬性',
    measurementType: '測數值型別',
    measurementTypeOptions: {
      1: '監測值',
      2: '變化值',
    },
    FirstLevelThreshold: '黃色閾值',
    thresholdPlaceholder: '請輸入閾值區間',
    AddThreshold: '添加橙色閾值區間',
    secondLevelThreshold: '橙色閾值',
    deleteSecondLevelThreshold: '刪除橙色閾值區間',
    addThirdThreshold: '添加紅色閾值區間',
    thirdLevelThreshold: '紅色閾值',
    deleteThirdLevelThreshold: '刪除紅色閾值區間',
    addContact: '添加連絡人',
    editContact: '編輯連絡人',
    delContact: '删除連絡人',
    contact: '連絡人',
    thresholdTip: {
      eg: '示例',
      tip1: '請使用數學區間表示',
      tip2: '請使用英文輸入法',
      tip3: {
        1: '可輸入數位',
        2: '小數點',
        3: '正無窮',
        4: '負無窮',
      },
      tip4: {
        1: '開區間',
        2: '閉區間',
        3: '半開閉區間',
      },
      tip5: {
        1: '多個區間用分號',
        2: '隔開',
      },
      tip6: {
        1: '表示',
        2: '或',
      },
    },
    configDeviceHealth: '配置設備健康閾值',
    monitorSwitch: '監控開關',
    voltageThreshold: '電壓閾值',
    voltageThresholdPlaceholder: '請輸入有效的閾值區間',
    lossTolerance: '丟失容限',
    lossTolerancePlaceholder: '請輸入有效的閾值區間',
    ruleListTitle: '規則清單',
    configAlarmRule: '配置報警通知規則',
    editAlarmRules: '編輯報警通知規則',
    deleteAlarmRule: '刪除報警規則',
    measuredValueAlarm: '測值類報警',
    levelPlaceholder: '請選擇報警等級',
    EquipmentAlarm: '設備類報警',
    mobileListPlaceholder: '請选择用於接收報警短信的手機號，可选多個手機',
    emailListPlaceholder: '請輸入用於接收報警郵件的郵箱，多個郵箱換行輸入',
    GnssSolutionConfig: 'GNSS解算配寘',
    ZrzybConfig: '物聯網雲平臺配寘',
    SDMPROSolutionConfig: '傾角振動計配寘',
    GnssConfig: {
      taskName: {
        label: '解算任務名',
      },
      BaseStation: {
        label: '基準站',
      },
      baseType: {
        label: '基准站类型',
      },
      FilteringTime: {
        label: '濾波時長',
        unit: '小時',
      },
      TaskInterval: {
        label: '解算任務間隔',
        unit: '分鐘',
      },
      taskMode: {
        label: '解算模式',
      },
      Smooth: {
        label: '平滑',
      },
    },
    memberManagementStatusOptions: {
      true: '禁用',
      false: '活動',
    },
    updateMember: '更新項目成員',
    at: '於',
    do: '進行',
    noRecord: '暫無操作記錄',
    structureInfo: '結構物資訊',
    pointDistribution: '測點分佈',
    deleteStructure: '刪除結構物',
    deleteStructureTitle: '刪除結構物，結構物下的測點數據將關聯刪除，請謹慎操作！',
    pointInfo: '測點信息',
    deviceInfo: '設備資訊',
    deviceConfiguration: '設備配置',
    zrzybwlwpt: '自然資源部物聯網雲平臺',
    zrzybwlwptConfig: '自然資源部物聯網雲平臺數據推送配寘',
    deviceTesting: '設備測試',
    dataPush: '數據推送',
    deleteMeasuringPoint: '刪除測點',
    deleteMeasuringPointTip: '刪除測點及其關聯資料，請謹慎操作！',
    dataMining: '數采',
    other: '其他',
    channel: '通道',
    deviceName: '設備名稱',
    serialNumber: '序號',
    manufacturer: '製造商',
    deviceModel: '設備型號',
    model: '型號',
    channels: '通道總數',
    occupiedChannel: '使用通道',
    networkConfiguration: '網路配置',
    register: '網路註冊碼',
    thresholdConfiguration: '閾值配置',
    monitoringField: '監測欄位',
    calculation: '計算方式',
    firstInterval: '黃色閾值區間',
    secondInterval: '橙色閾值區間',
    thirdInterval: '紅色閾值區間',
    deleteThreshold: '刪除閾值',
    listeningToData: '正在監聽資料',
    clearScreen: '清屏',
    toggleEncode: '切換編碼',
    queryCommands: '查詢類命令',
    settingCommands: '設置類命令',
    otherCommands: '其他命令',
    operationTips: '操作提示',
    tipsThreshold: '是否刪除閾值',
    collectionTime: '採集時間',
    nodeNum: '節點號',
    hangJob: '已掛起任務',
    collectConf: '採集配置',
    processorConf: '資料處理',
    formulaConf: '公式配置',
    chartConf: '圖表配置',
    addSlavePoint: '添加子測點',
    removeSlavePoint: '刪除子測點',
    createCommonPoint: '創建普通測點',
    createCompositePoint: '創建組合測點',
    contingencyPlan: '應急預案',
  },
  // 設備中心
  device: {
    equipmentCenter: '設備中心',
    addDevice: '添加設備',
    editDevice: '編輯設備',
    measuringEquipment: '測量設備',
    collectionEquipment: '採集設備',
    transmissionDevice: '傳輸設備',
    inputPlaceholder: '過濾名稱、序號、型號',
    measurementPlaceholder: '過濾監測類型',
    categoryPlaceholder: '過濾設備類別',
    filterSensor: '只看感測器',
    isMountedOptions: {
      true: '已關聯',
      false: '未關聯',
    },
    deleteDevice: '刪除設備',
    noConfiguration: '當前設備無須配置',
    DeviceConfiguration: {
      nodes: '節點號',
      segmentLen: '節點間距',
      initTwist: '初始偏移角',
      markAngle: '北偏轉角',
      chartDirection: '圖表縱軸',
      chartDirectionDown: '向下為正（深埋安裝）',
      chartDirectionUp: '向上為正（地上安裝）',
      elevation: '高程',
      version: '固件版本',
      zrzybIp: 'HTTP IP',
      zrzybPort: 'HTTP 埠號',
      zrzybApi: 'HTTP拓展接口(非必填)',
      zrzybDeviceId: 'MQTT用户名',
      zrzybDeviceKey: 'MQTT密码',
      zrzybDeviceNumber: '設備啟用監測序號',
      zrzybIsPush: '開啟推送',
      zrzybMsg: '如多個序號，請用英文逗號分隔，示例: 100001,100002,100003',
      // baseStationAgreementCode: '基準站協議類型',
      // baseStationIP: '基準站IP',
      // baseStationPort: '基準站埠號',
      // baseStationPoint: '基准站掛載點',
      // baseStationUsername: '基準站掛載用戶名',
      // baseStationPassword: '基準站掛載密碼',
      // baseStationX: '基準站X方向概略座標',
      // baseStationY: '基準站Y方向概略座標',
      // baseStationZ: '基準站Z方向概略座標',
      // baseStationNTRIPLng: '基準站NTRIP經度',
      // baseStationNTRIPLat: '基準站NTRIP緯度',
      // baseStationNTRIPHeight: '基準站NTRIP高度',
      agreementCode: '設備接入協議',
      port: '埠號',
      point: '挂载点',
      username: '掛載用戶名',
      password: '掛載密碼',
      gnssX: 'X方向概略座標',
      gnssY: 'Y方向概略座標',
      gnssZ: 'Z方向概略座標',
      NTRIPLng: 'NTRIP經度',
      NTRIPLat: 'NTRIP緯度',
      NTRIPHeight: 'NTRIP高度',
      deviceSerial: '海康序號',
      validateCode: '驗證碼',
      K: '靈敏度係數K',
      Kt: '溫度係數Kt',
      f0: '初始頻率f0',
      t0: '初始溫度t0',
      Kr: '雨量計係數Kr',
      iMin: '最小電流',
      iMax: '最大電流',
      fullscale: '量程',
      maxDepth: '最大深度',
      minDepth: '最小深度',
      nodeCount: '節點總數',
      mqttKey: 'MQTT-設備Key',
      deviceId: 'MQTT-設備ID',
    },
    log: {
      span1: '修改了',
      span2: '為',
    },
    bulkAddDevice: '批量導入設備',
    upload1: '選擇檔',
    upload2: '點擊下載',
    upload3: '範本檔.xlsx',
    upload4: '只能上傳 <範本檔.xlsx>，且不超過2MB',
    upload5: '選擇檔後繼續',
    deviceNum: '導入設備數：',
    failRow: '失敗行：',
  },
  // 設置
  setting: {
    updateCompleted: '更新成功',
    createAccount: '創建帳號',
    editAccount: '編輯帳號',
    deleteAccount: '刪除帳戶',
    roleTitle: '角色許可權管理',
    creatingRole: '創建角色',
    deleteRole: '刪除角色',
    editRole: '編輯角色',
    assignPermissions: '分配許可權',
    accountGroup: '帳號分組',
    createGroup: '創建分組',
    editGroup: '編輯分組',
    deleteGroup: '刪除分組',
  },
  // 個人中心
  profile: {
    baseInfo: '基本資訊',
    changePassword: '修改密碼',
    updateCompleted: '更新成功',
  },
  // 推送策略
  pushStrategy: {
    add: '創建策略',
    update: '修改策略',
    pushRuleTypes: {
      PushAdmACC: '推送加速度',
      PushAdmXYZ: '推送座標觀測值',
      PushAdmXYZChange: '推送座標變化值',
      PushAdmEN: '推送東北方位角',
      PushGlodonValue: 'Glodon格式推送（測試）',
    },
    timeOptions: {
      300000: '5分鐘',
      600000: '10分鐘',
      1800000: '30分鐘',
      3600000: '1小時',
      7200000: '2小時',
    },
  },
  operationLog: {
    key: '關鍵字',
    keyP: '請輸入IP / UA',
    scope: '模組',
    scopeP: '請選擇模組',
    action: '操作',
    actionP: '請選擇操作',
    scopeId: '模組ID',
    ip: 'IP',
    ua: '用戶端',
    content: '操作內容',
  },
  protocols: {
    ADM: 'HS-ADM',
    HDA2: 'HS-HDA（頻率資料）',
    HDA3: 'HS-HDA（電流資料）',
    HDA_HSL: 'HS-HDA（靜力水準）',
    HDA_FLOW: 'HS-HDA（流速資料）',
    HDA_RAIN: 'HS-HDA（雨量資料）',
    SDM: 'HS-SDM（傾角振動數據）',
    GDM: 'HS-GDM（GNSS數據）',
    ROCTEC_ADM: '接入岩石科技（ADM）',
    ROCTEC_HYDRO: '接入岩石科技（靜力水準儀）',
    ROCTEC_STATION: '接入岩石科技（全站儀）',
    ROCTEC_ZCYL: '接入岩石科技（支撐應力）',
    WHU_GNSS: '接入武大GNSS',
    HSAPP_RDM: '接入測斜儀APP',
    TGY_IDM: '接入同感雲（圖像位移）',
    HYDRO: '接入水文數據',
    OTHER: '其他協定（空協定）',
  },
};
